export default __webpack_public_path__ + "static/media/block-services-3.7efe13ef.webp";